var _style;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_x32_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "512px",
    height: "512px",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\n\t.st0{fill:#4B4B4B;}\n\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "331.389,314.125 279.452,314.125 273.858,322.797 273.858,343.594 331.389,343.594 331.389,343.656  331.389,368.875 331.389,373.109 273.858,373.109 273.858,417.656 238.139,417.656 238.139,373.109 180.624,373.109  180.624,368.875 180.624,343.656 180.624,343.594 238.139,343.594 238.139,322.828 232.561,314.125 180.624,314.125  180.624,288.906 216.327,288.906 185.967,241.672 216.249,241.672 255.983,303.516 295.764,241.672 326.03,241.672  295.686,288.906 331.389,288.906  ",
    style: {
      fill: "rgba(0, 0, 0, 1)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M476.232,174.734c2.203-8.547-2.953-17.266-11.516-19.484l-57.578-14.781l50.609-27.672 c7.75-4.234,10.594-13.969,6.359-21.719s-13.969-10.594-21.719-6.344l-64.062,35.047l39.219-95.25 c0.469-1.156,0.453-2.469-0.078-3.609c-0.516-1.141-1.5-2.016-2.688-2.422c0,0-31.688-16.438-49.594-16.438 c-37.063,0-73.047,19.422-105.828,19.422c-9.906,0-19.531-1.781-28.797-6.422C208.795,4.188,189.795,0,171.827,0 C144.655,0,96.53,18.766,96.53,18.766c-1.281,0.313-2.359,1.172-2.953,2.359c-0.594,1.172-0.641,2.547-0.141,3.766l43.172,104.859 c-5.328,2.625-9,8.031-9,14.344c0,5.438,2.719,10.234,6.875,13.125c-21.094,25.156-73.141,92.547-92.75,167.031 C13.467,431.703,76.514,512,255.405,512c178.906,0,241.953-80.297,213.687-187.75c-17.297-65.688-59.828-125.875-84.109-156.438 l71.781,18.438C465.311,188.453,474.029,183.297,476.232,174.734z M171.827,40c13.078,0,26.047,3.453,40.844,10.844 c14.109,7.063,29.828,10.641,46.688,10.641c21.266,0,41.078-5.438,60.25-10.688c16.391-4.5,31.859-8.734,45.578-8.734l1.875,0.031 l-35.406,86H179.17l-34.563-83.969C154.108,41.547,163.03,40,171.827,40z M419.811,421.094 C394.499,453.922,336.124,472,255.405,472c-80.703,0-139.078-18.078-164.391-50.906C74.499,399.656,70.92,370.5,80.42,334.438 c21.906-83.25,91.844-159.766,92.516-160.5l12.844-13.844h139.266l12.844,13.844c0.703,0.766,70.469,76.719,92.515,160.5 C439.904,370.5,436.326,399.656,419.811,421.094z",
    style: {
      fill: "rgb(0, 0, 0, 1)"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReward);
export default __webpack_public_path__ + "static/media/reward.5cb714eb998f12ef9a6438ac55601302.svg";
export { ForwardRef as ReactComponent };